<span [ngStyle]="letterColor" class="letter-icon">{{ initialLetter }}</span>
